var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#00864D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2604 5.25628C12.5799 5.59799 12.5799 6.15201 12.2604 6.49372L7.35127 11.7437C7.19783 11.9078 6.98972 12 6.77273 12C6.55573 12 6.34762 11.9078 6.19419 11.7437L3.73964 9.11872C3.42012 8.77701 3.42012 8.22299 3.73964 7.88128C4.05916 7.53957 4.5772 7.53957 4.89672 7.88128L6.77273 9.88756L11.1033 5.25628C11.4228 4.91457 11.9408 4.91457 12.2604 5.25628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.382e992f3613e5e375eca4fad9e9ab34.svg";
export { ForwardRef as ReactComponent };